<script>
  import _ from 'lodash'
  import { h, compile } from 'vue/dist/vue.esm-bundler'

  import VueTypes from 'vue-types'
  import QuestionsForm from '../components/questions-form'
  import PDFViewer from '../components/pdf-viewer'

  export default {
    name: 'TrainingSlide',
    components: {
      'questions-form': QuestionsForm,
      'pdf-viewer': PDFViewer,
    },
    props: {
      // スライドを表示するかどうか
      initshow: VueTypes.bool.def(false),
      // 遅延なしにスライドを表示するかどうか
      immediage: VueTypes.bool.def(false),
      // ページ番号
      page: VueTypes.number,
      // 表示するスライドコンテンツ
      html: VueTypes.string
    },
    data () {
      return {
        templateRenderer: null,
        show: this.initshow,
      }
    },
    render (createElement) {
      if (this.templateRenderer) {
        return this.templateRenderer
      } else {
        return h('div', 'loading...')
      }
    },
    methods: {
      createTemplateRenderer() {
        const res = (this.immediage) ? compile(`<div class="slide" v-show="${this.show}">${this.html}</div>`)
                                       : compile(`<div class="slide" v-if="${this.show}">${this.html}</div>`)
        this.templateRenderer = h({render: res})
      }
    },
    watch: {
      html: {
        immediate: true,
        handler () {
          this.createTemplateRenderer()
        }
      },
      show: {
        immediate: false,
        handler () {
          this.createTemplateRenderer()
        }
      }
    }
  }
</script>
